export class LeaderboardApi {
    public static getLeaderboard = (code: string) => `/tournament/${code}/leaderboard`;
}
